import { PageHeader } from '@/components'
import { useCompany } from '@/context/companies'
import { InvoicesList } from './invoices-list'

export function BillingPage() {
  const { company } = useCompany()

  return (
    <>
      <PageHeader>Pagamentos</PageHeader>

      <InvoicesList dealKey={company.deal.key} />
    </>
  )
}
